import UseContext from "hooks/useContext";


const useSlideOver = () => {
    const {slideOverShow,setSlideOverShow,setSlideOverType}=UseContext()

    function toggleSlideOver(v) {
        if (v === undefined || v === '') {
            if (slideOverShow) {
                setSlideOverType('')
            }
            setSlideOverShow(!slideOverShow)
            return
        }
        setSlideOverType(v)
        setSlideOverShow(true)
    }

    return {
        toggleSlideOver
    };
};

export default useSlideOver;